import React from "react";
import { Grid, Typography, Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { CTBox, StyledGrid, StyledH3Heading } from "../style/StyledComponents";

const qAndA = [
  {
    q: `Is clipThoughts' storing your data?`,
    a: `We do not store any of your information, including podcasts, notes, and annotations. All data is stored locally in your browser's storage. If you delete your browser history, you will lose this data. Therefore, we recommend saving your data in ClipThoughts' JSON format, which you can later upload using the load button.`
  },
  {
    q: `How do I save my podcast bookmark and notes?`,
    a: `We highly recommend that you save your bookmark and notes. You can save bookmark in ClipThoughts's JSON format by clicking on the save button on podcast. You can load your bookmarks and notes by clicking on the load button next to the submit button. Other than that you can also export in different format such as MarkDown, TXT and PDF.`
  },
  {
     q: `What is RSS Feed?`,
    a: (
      <>
        Every podcast has an RSS (Really Simple Syndication) feed. It allows user to access updates to online content in a standardized, computer-readable format. RSS feed typically is in XML Format. It includes metadata information about podcast. You can find RSS Feed for your podcast on <a href="https://castos.com/tools/find-podcast-rss-feed" target="_blank" rel="noopener noreferrer">https://castos.com/tools/find-podcast-rss-feed/</a>.
        Some example of the RSS feed include:
        <ul>
          <li>Crime Junkie - https://feeds.simplecast.com/qm_9xx0g</li>
          <li>Smosh Reads Reddit Stories - https://feeds.megaphone.fm/smoshreadsredditstories</li>
          <li>Cancelled with Tana Mongeau & Brooke Schofield - https://audioboom.com/channels/5134106.rss</li>
          <li>Founders talk - https://audioboom.com/channels/5134106.rss</li>
        </ul>
      </>
    )
  },
  {
    q: `What are some Keyboard shortcuts?`,
    a: (
      <ul>
        <li><Typography variant="body1"><strong>Space</strong>: Start or Play (Use left arrow/right arrow key to change tabs and press space to play that section) </Typography></li>
        <li><Typography variant="body1"><strong>o</strong>: Loop</Typography></li>
        <li><Typography variant="body1"><strong>Left Arrow</strong>: Move Tab Backward</Typography></li>
        <li><Typography variant="body1"><strong>Right Arrow</strong>: Move Tab Forward</Typography></li>
        <li><Typography variant="body1"><strong>h</strong>: Step Backward by 1 second</Typography></li>
        <li><Typography variant="body1"><strong>l</strong>: Step Forward by 1 second</Typography></li>
      </ul>
    )
  }
]

const PodcastFaqSection = () => {
  return (
    <>
    <CTBox sx={{padding: "2rem"}}>
      <StyledH3Heading>FAQ</StyledH3Heading>
      <StyledGrid container spacing={2}>
        {qAndA.map((item, index) => (
          <Grid item xs={12} key={index}>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel${index}-content`}
                id={`panel${index}-header`}
              >
              <Typography variant="body1">{item.q}</Typography>
              </AccordionSummary>
              <AccordionDetails>{item.a}</AccordionDetails>
            </Accordion>
          </Grid>
        ))}
      </StyledGrid>
    </CTBox>
    </>
  );
}

export default PodcastFaqSection;